import React from "react";
import Modal from "react-modal";
import { translate } from "application/functions";
import cancel from "assets/img/black-cancel.png";

const ModalUpload = ({ showModal, onCancel, selectedImage, onDelete, onUpdate, indexSelectedImage }) => {
  const customStyles = {
    overlay: {
      background: "rgba(255, 255, 255, 0.95)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      background: "none",
      transform: "translate(-50%, -50%)",
      border: "none",
      width: "100%",
      height: "100%",
      borderRadius: "0",
      padding: "0",
    },
  };
  return (
    <>
      <Modal isOpen={showModal} style={customStyles} contentLabel="Modal upload">
        <div className="modal__container-upload">
          <div className="modal__container-upload-cancel" onClick={() => onCancel()}>
            <img src={cancel} alt="cancel" title="cancel" />
          </div>
          <button
            onClick={() => {
              onDelete(selectedImage, indexSelectedImage);
            }}
          >
            {" "}
            {translate("deletePhoto")}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ModalUpload;
